"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var props = _ref.props,
      monitor = _ref.monitor;
  return props.currentBoardId !== props.elementId;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/canDrop/preventDropOnCurrentBoardPredicate.js
// module id = 1975
// module chunks = 0